module.exports = __webpack_public_path__ + "img/green.ab954156.png";